import * as React from "react";
import {connect} from 'react-redux';
import * as agGrid from "ag-grid-community/main";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"
import toastr from "toastr";
import moment from "moment";
import urlencode from "urlencode";
import {AttributeTypeEnum} from "../../components/bo-core/enums/AttributeTypeEnum";
import AgSelectAllHeader from "../../components/bo-core/common/AgSelectAllHeader";
import Axios from "../../config/Axios";
import Utils from "../../Utils";
import AgGridFooter from "../../components/bo-core/common/AgGridFooter";
import LoadingModal from "../../components/bo-core/modals/LoadinModal";
import {deleteTags, mergeTags, updateTagName} from "../../actions/boCoreActions";
import {setTitle} from "../../actions/topHeaderActions";
import AgGridUtils from "../../AgGridUtils";


interface State {
    grid: any
    loading: boolean;
    margeIntoId: number;
}

interface Props {
    title: any;

    mergeTags(dto: object, successCallBack?: any, rejectCallBack?: any): void;

    deleteTags(ids: number[], successCallBack?: any, rejectCallBack?: any): void;

    updateTagName(id: number, name: string, successCallBack?: any, rejectCallBack?: any): void;

    setTitle(title: string): void;
}

class TagManagementGrid extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            grid: null,
            loading: false,
            margeIntoId: -1
        }
    }

    componentDidMount(): void {
        this.props.setTitle("Tag Management");
        this.build();
    }

    componentWillUnmount(): void {
        this.props.setTitle("");
        $("#hide-nav-btn").off();
    }

    build(): void {
        const columnDef: any = [
            {
                field: "quickFilter", hide: true, lockVisible: true,
                filterParams: {
                    newRowsAction: "keep"
                },
                dataType: AttributeTypeEnum.TEXT
            },
            {
                headerName: "ID",
                width: 50,
                field: "id",
                checkboxSelection: true,
                dataType: AttributeTypeEnum.INT,
                headerComponent: AgSelectAllHeader
            },
            {
                headerName: "Merge Into",
                width: 20,
                field: undefined,
                cellRenderer: function (params) {
                    return `<input class="merge-into-radio" style="width: 18px; height: 18px" type="radio" name="merge_into">`
                },
                dataType: AttributeTypeEnum.INT
            },
            {
                headerName: "Name",
                width: 50,
                field: "name",
                editable: true,
                dataType: AttributeTypeEnum.TEXT
            },
            {
                headerName: "Instance Count",
                width: 50,
                field: "instancesCount",
                dataType: AttributeTypeEnum.INT,
            },
            {
                headerName: "Updated", width: 50, field: "updated",
                dataType: AttributeTypeEnum.TIMESTAMP
            }
        ];


        const gridOptions: any = {
            defaultColDef: {
                resizable: true,
                sortable: true,
                filter: "agTextColumnFilter",
                filterParams: {
                    filterOptions: ['contains'],
                    applyButton: true,
                    clearButton: true,
                    suppressAndOrCondition: true
                },
                floatingFilterComponentParams: {suppressFilterButton: true},
                menuTabs: ['generalMenuTab']
            },
            suppressDragLeaveHidesColumns: true,
            cacheQuickFilter: this.refs.quickFilterBox,
            onGridReady: (params: any) => {
                params.api.sizeColumnsToFit();
            },
            onCellClicked: (params) => {
                if (params.event.target.classList.contains('merge-into-radio')) {
                    this.setState({margeIntoId: params.data.id});
                }
            },
            onCellEditingStopped: (event) => {
                console.warn("A");
                this.setState({loading: true}, () => {
                    console.warn("B");
                    this.props.updateTagName(event.data.id, event.data.name, () => {
                        this.setState({loading: false});
                        toastr.success("Tag name updated successfully");
                    }, (e: any) => {
                        try {
                            toastr.error(e.response.data.message);
                        } catch (error) {
                            console.error(error);
                        } finally {
                            this.setState({loading: false});
                        }
                    })
                });
            },
            onRowSelected: (params: any) => {
                this.state.grid.gridOptions.selectAllHeader.onRowSelected(params);
                this.forceUpdate();
            },
            onFilterChanged: () => {AgGridUtils.deselectAllRows(this.state.grid.gridOptions.api)},
            suppressRowClickSelection: true,
            suppressPropertyNamesCheck: true,
            columnDefs: columnDef,
            floatingFilter: true,
            rowSelection: 'multiple',
            rowModelType: 'serverSide',
            cacheBlockSize: 100,
            maxBlocksInCache: 500,
            maxConcurrentDatasourceRequests: 2,

            animateRows: true,
            debug: false
        };

        const grid = new agGrid.Grid((this.refs.gridRef as HTMLElement), gridOptions);
        gridOptions.api.setServerSideDatasource(this.ServerSideDatasource());
        this.setState({grid});

        $("#hide-nav-btn").on("click", function () {
            setTimeout(() => {
                gridOptions.api.sizeColumnsToFit();
            }, 500);
        });
    };

    ServerSideDatasource() {
        return {
            getRows: (params: any) => {
                const limit = params.request.endRow - params.request.startRow;
                const page = (params.request.endRow / limit) - 1;
                const sort = AgGridUtils.generateSortData(params.request.sortModel);
                const filter = generateFilterData(params);
                Axios.instance.get(`tags/details?filter=${urlencode(JSON.stringify(filter))}&sort=${urlencode(JSON.stringify(sort))}&page=${page}&limit=${limit}`)
                    .then((response: any) => {
                        const dataArray = response.data.content.map(item => {
                            return {
                                id: item.id,
                                name: item.name,
                                instancesCount: item.instancesCount,
                                updated: moment(item.updated, moment.ISO_8601).isValid() ? moment.utc(item.updated).utcOffset(moment(item.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss') : item.updated
                            }
                        });
                        try {
                            const lastRow = dataArray.length < limit ? params.request.startRow + dataArray.length : -1;
                            params.successCallback(dataArray, lastRow);
                            this.state.grid.gridOptions.selectAllHeader.update(response.data.totalElements, (limit * (page + 1)) > response.data.totalElements ? response.data.totalElements : (limit * (page + 1)), params.parentNode.gridApi.getSelectedRows().length);
                            if (this.state.grid.gridOptions.selectAllHeader.isSelected()) {
                                this.state.grid.gridOptions.selectAllHeader.selectAll();
                            }
                            this.state.grid.gridOptions.api.sizeColumnsToFit();
                            this.forceUpdate();
                        } catch (e) {
                            console.error(e);
                        }
                    })
                    .catch((e) => {
                        AgGridUtils.serverSideErrorHandler(e)
                        params.failCallback();
                    })
            }
        }
    }

    onMerge = () => {
        const tagIds = this.state.grid.gridOptions.api.getSelectedRows().map((item: any) => item.id);
        Utils.$('#merge-tags').blur();
        if (tagIds.length > 0 && this.state.margeIntoId !== -1) {
            Utils.$.confirm({
                title: 'Confirm?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                content: `You are about to merge ${tagIds.length} tags, this procedure is irreversible.`,
                type: 'red',
                theme: 'dark',
                typeAnimated: false,
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            const dto = {
                                mergedTagsIds: tagIds,
                                mergeToTagId: this.state.margeIntoId
                            };
                            this.setState({loading: true}, () => {
                                this.props.mergeTags(dto,
                                    () => {
                                        this.setState({loading: false}, () => {
                                            toastr.success("Tags merged successfully.");
                                            this.state.grid.gridOptions.api.deselectAll();
                                            this.state.grid.gridOptions.api.onFilterChanged();
                                        })
                                    },
                                    (e: any) => {
                                        try {
                                            toastr.error(e.response.data.message);
                                        } catch (error) {
                                            console.error(error);
                                        } finally {
                                            this.setState({loading: false});
                                        }
                                    })
                            });
                        }
                    },
                    cancel: () => {
                    }
                }
            });
        }
    };

    onDelete = () => {
        const tagIds = this.state.grid.gridOptions.api.getSelectedRows().map((item: any) => item.id);
        Utils.$('#delete-tags').blur();
        if (tagIds.length > 0) {
            Utils.$.confirm({
                title: 'Confirm?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                content: `You are about to delete ${tagIds.length} tags, this procedure is irreversible.`,
                type: 'red',
                theme: 'dark',
                typeAnimated: false,
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            this.props.deleteTags(tagIds,
                                () => {
                                    this.state.grid.gridOptions.api.deselectAll();
                                    this.state.grid.gridOptions.api.onFilterChanged();
                                }, (e: any) => {
                                    console.log('Error while deleting tag');
                                    console.log(e);
                                })

                        }
                    },
                    cancel: () => {
                    }
                }
            });
        }
    };

    render(): React.ReactNode {
        return (
            <div style={{height: "100%"}} className="bo-core">
                <div style={{
                    backgroundColor: "#2D3436",
                    height: 50,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }} className={'top-header'}>
                    <div>
                        <span id="tagManagementLabel" className="header-title">{this.props.title}</span>
                    </div>
                    <div>
                        <button onClick={this.onMerge.bind(this)} id={'merge-tags'} style={{
                            height: 36,
                            marginTop: 1,
                            marginRight: 1
                        }}
                                className="btn btn-warning">
                            <i className="fas fa-object-group"></i> Merge
                        </button>
                        <button onClick={this.onDelete.bind(this)} id={'delete-tags'} style={{
                            height: 36,
                            marginTop: 1,
                            marginRight: 1,
                            marginLeft: 3
                        }}
                                className="btn btn-danger">
                            <i className="fas fa-trash-alt"></i> Delete
                        </button>
                    </div>
                </div>
                <div style={{width: "100%", height: "calc(100% - 75px)",padding: 10, backgroundColor: '#2D3436'}}>
                    <div ref={"gridRef"} className={"ag-theme-balham-dark ag-grids"}
                         style={{width: "100%", height: "100%"}}/>
                    <AgGridFooter
                        totalCount={this.state.grid ? this.state.grid.gridOptions.selectAllHeader.getState().totalItemsCount : 0}
                        loadedCount={this.state.grid ? this.state.grid.gridOptions.selectAllHeader.getState().loadedItemsCount : 0}
                        selectedCount={this.state.grid ? this.state.grid.gridOptions.selectAllHeader.getState().selectedItemsCount : 0}
                    />
                </div>
                <LoadingModal open={this.state.loading}/>
            </div>
        )
    }
}

const generateFilterData = (params: any): any => {
    const filter = {};
    const filterModel = params.request.filterModel;
    Object.keys(filterModel).map(key => {
        if (key !== "quickFilter") {
            const column = params.parentNode.gridApi.getColumnDef(key);
            if (column.dataType === AttributeTypeEnum.TIMESTAMP) {
                filter[key] = filterModel[key].filter.replace(/\d{4}(-\d\d(-\d\d([T| ]\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?/g, function (a) {
                    if (moment(a, moment.ISO_8601).isValid()) {
                        const format = moment(a).creationData().format;
                        if (format === "YYYY-MM" || format === "YYYY-MM-DD") {
                            return a;
                        } else {
                            // @ts-ignore
                            return moment.tz(a, format, moment()._z.name).utc().format(format);
                        }
                    }
                    return a;
                });
            } else {
                filter[key] = filterModel[key].filter
            }
        }
    });
    return filter;
};

const mapStateToProps = (state, ownProps) => {
    return {
        title: state.topHeader.title
    }
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        mergeTags: (dto: object, successCallBack?: any, rejectCallBack?: any) => {
            dispatch(mergeTags(dto, successCallBack, rejectCallBack))
        },
        deleteTags: (ids: number[], successCallBack?: any, rejectCallBack?: any) => {
            dispatch(deleteTags(ids, successCallBack, rejectCallBack))
        },
        updateTagName: (id: number, name: string, successCallBack?: any, rejectCallBack?: any) => {
            dispatch(updateTagName(id, name, successCallBack, rejectCallBack))
        },
        setTitle: (title) => {
            dispatch(setTitle(title))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TagManagementGrid)



// WEBPACK FOOTER //
// ./app/views/bo-core/TagManagementGrid.tsx